import { Team } from "../../types";

export const lcsTeams: Team[] = [
  {
    name: "EG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1592590374862_EvilGeniusesEG-01-FullonDark.png",
    seed: 1,
  },
  {
    name: "100T",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819887423_100t-2021-worlds.png",
    seed: 2,
  },
  {
    name: "TL",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631820014208_tl-2021-worlds.png",
    seed: 3,
  },
  {
    name: "CLG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1592590248482_CounterLogicGamingCLG-01-FullonDark.png",
    seed: 4,
  },
  {
    name: "C9",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631820065346_cloud9-2021-worlds.png",
    seed: 5,
  },
  {
    name: "FLY",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2Fflyquest-new-on-dark.png",
    seed: 6,
  },
  {
    name: "TSM",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1592590917094_TSMTSM-01-FullonDark.png",
    seed: 7,
  },
  {
    name: "GG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1592590586919_GoldenGuardiansGGS-01-FullonDark.png",
    seed: 8,
  },
];
